import { requestApi } from '../util/network'
// 获取推荐人
export const getInviterInfo =
  (inviter_id) =>
    requestApi(
      '/Login/get_inviter',
      'POST',
      {
        'inviter_id': inviter_id
      }
    )
// 游客登录,自动注册
export const auto_register =
  (username) =>
    requestApi(
      '/Login/auto_register',
      'POST',
      {username}
    )
// 用户注册
export const register =
  (username, password, passwordConfirm, inviterId, member_email, email_code) =>
    requestApi(
      '/Login/register',
      'POST',
      {
        'username': username,
        'password': password,
        'password_confirm': passwordConfirm,
        'inviter_id': inviterId,
        // 'member_nickname': member_nickname,
        // 'member_mobile': member_mobile,
        'member_email': member_email,
        'email_code': email_code,
        'client': 'wap'
      }
    )
// 用户手机注册
export const registerByMobile =
  (phone, password, passwordConfirm, captcha, inviterId) =>
    requestApi(
      '/Connect/sms_register',
      'POST',
      {
        'phone': phone,
        'password': password,
        'password_confirm': passwordConfirm,
        'captcha': captcha,
        'inviter_id': inviterId,
        'client': 'wap'
      }
    )
